export default __webpack_public_path__ + "static/media/glide-logo_purple.f64c71e4.png";